import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

interface TrendIndicatorProps {
  value: number | null;
}

export function TrendIndicator({ value }: TrendIndicatorProps) {
  if (value === null || value === undefined) {
    return null;
  }

  const isPositive = value >= 0;
  const color = isPositive ? 'success.main' : 'error.main';
  const Icon = isPositive ? TrendingUpIcon : TrendingDownIcon;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
      <Icon sx={{ fontSize: 16, color }} />
      <Typography variant="body2" sx={{ color, fontWeight: 500 }}>
        {isPositive ? '+' : ''}
        {value.toFixed(1)}%
      </Typography>
    </Box>
  );
}
